

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Decoration extends Vue {
  name = ['line1', 'line2', 'circle'];
  r = Math.floor(Math.random() * this.name.length);

  c = 0;
  o = 0;
  s = 0;

  @Prop({ default: 0 })
  count?: number;
  @Prop({ default: 0 })
  offset?: number;
  @Prop({ default: 0 })
  size?: number;

  @Watch('count')
  watchCount(count: number) {
    this.c = count;
  }

  @Watch('offset')
  watchOffset(offset: number) {
    this.o = offset;
  }

  @Watch('size')
  watchSize(size: number) {
    this.s = size;
  }

  getAnimation(i: number, name: string) {
    if (name == 'circle') return Math.random() > 0.5 ? 'rotateR' : 'rotateL';
    if (i % 2 == 0) return Math.random() > 0.5 ? 'moveLeft' : 'moveLeft2';
    return Math.random() > 0.5 ? 'moveRight' : 'moveRight2';
  }
}
